import loadingScene from "./assets/textures/loading-scene.avif?url"
import roofTileColor from "./assets/textures/roof-tile-color.avif?url"
import roofTileNormalGl from "./assets/textures/roof-tile-normal-gl.avif?url"
import smoke from "./assets/textures/smoke.avif?url"
import towerLSignTexture from "./assets/textures/tower-l-sign.avif?url"

export default [
  {
    name: "smoke",
    type: "texture",
    path: smoke,
  },
  {
    name: "loading-scene",
    type: "texture",
    path: loadingScene,
  },
  {
    name: "balcony-floor-map",
    type: "texture",
    path: roofTileColor,
  },
  {
    name: "balcony-floor-normal",
    type: "texture",
    path: roofTileNormalGl,
  },
  {
    name: "tower-l-sign",
    type: "texture",
    path: towerLSignTexture,
  },
]
